import React from "react";
import LogoLink from "@insightfulscience/atomic-react/LogoLink";

export const logoPath = "/images/dotmatics/omiq/logo/logo-omiq-simple.svg";
export const logoAlt = "Omiq by Dotmatics";

const prerenderedLogo = (
	<LogoLink
		href="/"
		imgSrc={logoPath}
		alt={logoAlt}
		data-qa-selector="header-logo"
	/>
);

export default prerenderedLogo;
